const NAV_OFFSET_PX = 72;

/**
 * Smooth-scroll the results pane under the fixed navbar after a pagination click.
 */
export function scrollResultsIntoView(element) {
    if (!element) {
        return;
    }

    const top = element.getBoundingClientRect().top + window.pageYOffset - NAV_OFFSET_PX;
    window.scrollTo({
        top: Math.max(0, top),
        behavior: 'smooth',
    });
}
